import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {
  getBacksplashTotalArea,
  getCountertopArea, getEdgesArea,
  manualCalculationsBacksplashArea,
  manualCalculationsCountertopArea,
  manualCalculationsEdgesLength,
} from "../helpers/sqftCalculations";
import SqftFooterAddToQuoteButton from "./SqftFooterAddToQuoteButton";
import SqftFooterCancelButton from "./SqftFooterCancelButton";
import SqftFooterActiveShapeColorset from "./sqftFooterActiveShapeColorset";
import SqftFooterSlabInfo from "./sqftFooterSlabInfo";
import sqftConfig from "./canvas/store/sqftConfig";
import {MEASURE_UNITS, SIDEBAR_BUTTONS_MENU} from "../constants";
import {setSQFTActiveButton, setSQFTMenuOpened} from "../../../actions/sqftMenuFunctions";
import sqftSlabManager from "./canvas/store/sqftSlabManager";
import Config from "../../../config";

const SqftFooter = (props) => {
  const {updateCalculations, showManualCalculation, croppedSlabImages, fabricatorData, isMobile, isShowSlabTool,
    menuOpened} = props;
  const {countertopRows, backsplashRows, edgeRows} = props;
  const {setSQFTActiveButton, setSQFTMenuOpened} = props;
  const [countertopArea, setCountertopArea] = useState(0);
  const [edgesArea, setEdgesArea] = useState(0);
  const [backsplashArea, setBacksplashArea] = useState(0);
  const [slabTotal, setSlabTotal] = useState(0);

  useEffect(() => {
    setCountertopArea(
      showManualCalculation ? manualCalculationsCountertopArea() : getCountertopArea().totalAreaToMeasureUnit
    );
    setEdgesArea(showManualCalculation ? manualCalculationsEdgesLength() : getEdgesArea());
    setBacksplashArea(showManualCalculation ? manualCalculationsBacksplashArea() : getBacksplashTotalArea());
    setSlabTotal(
      croppedSlabImages.length + sqftSlabManager.getSlabPlaceHolderShapes().length
    );
  }, [updateCalculations, showManualCalculation, croppedSlabImages, countertopRows, backsplashRows, edgeRows]);
  const countertopMeasureUnit = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? ' m²' : '\'';
  const edgesMeasureUnit = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? ' m' : ' lnft';
  const backsplashMeasureUnit = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? ' m²' : '\'';
  //const slabMeasureUnit = sqftConfig.measureUnit === MEASURE_UNITS.Metric ? ' m²' : '\'';

  const handleViewSummaryClick = () => {
    setSQFTActiveButton(SIDEBAR_BUTTONS_MENU.summary);
    setSQFTMenuOpened(menuOpened === SIDEBAR_BUTTONS_MENU.summary ? "" : SIDEBAR_BUTTONS_MENU.summary);
  }

  return (
    <div className="info-bar">
      <div className="info-bar-content">
        {
          isShowSlabTool ?
            <div className="info-panel-wrapper">
              <button className="info-panel-title info-panel-button__hidden" onClick={handleViewSummaryClick}>
                <FormattedMessage id={"sqft.footer.viewSummary"}/>
              </button>
            </div>
          : ""
        }
        <div className="info-panel-wrapper">
          <span className="info-panel-title">
            <FormattedMessage id={"sqft.footer.countertopSize"}/>
          </span>
          <span className="info-panel-container info-panel-total">
            <span>{countertopArea}{countertopArea > 0 ? countertopMeasureUnit : null}</span>
          </span>
        </div>
        <div className="info-panel-wrapper info-panel-edging">
          <span className="info-panel-title">
            <FormattedMessage id={"sqft.footer.totalEdging"}/>
          </span>
          <span className="info-panel-container info-panel-edging__value">
            <span>{edgesArea}{edgesArea > 0 ? edgesMeasureUnit : null}</span>
          </span>
        </div>
        <div className="info-panel-wrapper info-panel-backsplash">
          <span className="info-panel-title" data-text="sqft.footer.totalBacksplash">
            <FormattedMessage id={"" +
            "sqft.footer.totalBacksplash"}/>
          </span>
          <span className="info-panel-container info-panel-backsplash__value">
            <span>{backsplashArea}{backsplashArea > 0 ? backsplashMeasureUnit : null}</span>
          </span>
        </div>
        {(fabricatorData.settings.showSlabMode || Config.isDevMode()) && !isMobile ?
        <div className="info-panel-wrapper info-panel-backsplash">
          <span className="info-panel-title" data-text="sqft.footer.totalBacksplash">
            <FormattedMessage id={"sqft.footer.totalSlab"}/>:
          </span>
          <span className="info-panel-container info-panel-backsplash__value">
            <span>{slabTotal > 0 ? '#' : null}{slabTotal}</span>
          </span>
          <SqftFooterSlabInfo/>
        </div> : null}
        <div className="info-panel-wrapper info-panel-colorset">
          <SqftFooterActiveShapeColorset/>
        </div>
      </div>
      <div className="info-bar-buttons info-bar-buttons--hide">
        <button data-id="nav_calculate_open" data-action="manual-button" className="back-button buttons2__button buttons2__button--next hide" data-text="sqft.footer.buttonCalculateManually">
          <FormattedMessage id={"sqft.footer.buttonCalculateManually"}/>
        </button>
        <button data-id="nav_calculate_close" data-action="manual-button" className="back-button buttons2__button buttons2__button--prev hide" data-text="sqft.footer.buttonBackToDraw">
          <FormattedMessage id={"sqft.footer.buttonBackToDraw"}/>
        </button>
        <SqftFooterCancelButton/>
        <SqftFooterAddToQuoteButton/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  menuOpened: store.sqftMenuState.menuOpened,
  updateCalculations: store.sqftState.updateCalculations,
  croppedSlabImages: store.sqftSlabState.croppedSlabImages,
  countertopRows: store.sqftManualCalculationState.countertopRows,
  backsplashRows: store.sqftManualCalculationState.backsplashRows,
  edgeRows: store.sqftManualCalculationState.edgeRows,
  showManualCalculation: store.sqftManualCalculationState.showManualCalculation,
  fabricatorData: store.fabricatorState,
  isMobile: store.serverState.isMobile,
  isShowSlabTool: store.sqftSlabState.isShowSlabTool,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setSQFTMenuOpened
};


export default connect(mapStateToProps, mapDispatchToProps)(SqftFooter);
